import Loader from 'components/Loader'
import BoardDataProvider from 'dataProviders/Board'
import React from 'react'
import ActivitiesConnected from './ActivitiesConnected'

type Props = {
  boardId: number
}

const ActivitiesWithBoardDataProvider: React.FC<Props> = ({
  boardId,
}) => {
  return (
    <BoardDataProvider
      id={boardId}
    >
      {({ isReady }) =>
        isReady
          ? (
            <ActivitiesConnected
              id={boardId}
            />
          )
          : <Loader center className='m-t-10 m-b-10' />
      }
    </BoardDataProvider>
  )
}

export default ActivitiesWithBoardDataProvider
